import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

@Injectable()
export class QaService {
  public hostUrl: any = environment.API_BASE_URL;
  public urlToGetCallLogByAccount: any = this.hostUrl + 'api/getCallLogByAccountId';

  constructor(private _http: HttpClient) {}

  public getCallLogByAccountId(data): Observable<any> {
    return this._http.post(this.urlToGetCallLogByAccount, data).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/qa.service.ts